import { render, staticRenderFns } from "./PelatihanPetani.vue?vue&type=template&id=530bdd8b"
import script from "./PelatihanPetani.vue?vue&type=script&lang=js"
export * from "./PelatihanPetani.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports